import { SpanStatusCode, trace } from "@opentelemetry/api";

const tracer = trace.getTracer("intranet-frontend");

export type ReportAttributes = Record<
  string,
  string | number | boolean | undefined
>;

/**
 * Records an application-level failure on a span (so it is not just a generic
 * HTTP span) and emits one structured console line with the trace id. Returns
 * the trace id for callers that want to surface it.
 */
export const reportError = (
  operation: string,
  error: unknown,
  attributes: ReportAttributes = {},
): string => {
  const message = error instanceof Error ? error.message : String(error);

  const span = tracer.startSpan(operation, {
    attributes: {
      operation,
      ...attributes,
      "error.message": message,
    },
  });
  const traceId = span.spanContext().traceId;

  span.recordException(error instanceof Error ? error : new Error(message));
  span.setStatus({ code: SpanStatusCode.ERROR, message });
  span.end();

  // eslint-disable-next-line no-console
  console.error(`[${operation}] ${message}`, {
    operation,
    traceId,
    ...attributes,
  });

  return traceId;
};
